import { DocumentTitle } from 'components/DocumentTitle';
import { DetailsPage } from 'components/page/DetailsPage';
import { RouteButtonTabs } from 'components/tabs/RouteButtonTabs';
import { TabRouter } from 'components/tabs/TabRouter';
import { useAnalyticsModel } from 'custom_hooks/data_hooks/analytics_models/useAnalyticsModel';
import { useRouteTabs } from 'custom_hooks/data_hooks/data_source/useRouteTabs';
import { ContentTabConfig } from 'custom_hooks/data_hooks/data_source/useTabs';
import {
    AssignedModelTab,
    AssignedModelTabProps,
} from 'pages/Models/AssignedModalTab/AssignedModelTab';
import { AnalyticsModelDetails } from 'pages/Models/Development/AnalyticsModelDetails';
import { AnalyticsModelLogs } from 'pages/Models/Development/AnalyticsModelLogs';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export function AnalyticsModelDevelopment({
    corporation,
    location,
}: AssignedModelTabProps) {
    const { modelId } = useParams<{ modelId: string }>();

    const { data: model, isLoading, error } = useAnalyticsModel(modelId);

    const tabs = useMemo<ContentTabConfig[]>(
        () => [
            {
                id: 'details',
                label: 'Details',
                content: model && <AnalyticsModelDetails analyticsModel={model} />,
            },
            {
                id: 'logs',
                label: 'Logs',
                content: (
                    <AnalyticsModelLogs
                        modelId={modelId}
                        disableDate={model?.DisableDate}
                    />
                ),
            },
            {
                id: 'assignments',
                label: 'Assignments',
                content: (
                    <AssignedModelTab
                        corporation={corporation}
                        location={location}
                        analyticsModelId={modelId}
                    />
                ),
            },
        ],
        [model, modelId, corporation, location],
    );

    const { routeTabs, currentTab } = useRouteTabs(tabs);

    if (typeof currentTab?.label !== 'string' && currentTab?.label !== undefined) {
        throw new Error('this page expects the tab label to be a string');
    }

    return (
        <DetailsPage
            error={error ? 'Unable to load model' : undefined}
            invalidURL={!model && !isLoading && !!error}
            isLoading={isLoading}
            fullHeight
            fullWidth
        >
            {model && (
                <>
                    <DocumentTitle
                        title={`${model.Name} Model ${currentTab?.label ?? 'Settings'}`}
                    />
                    <div className="flex p-20">
                        <RouteButtonTabs routeTabs={routeTabs} />
                    </div>
                    <TabRouter routeTabs={routeTabs} />
                </>
            )}
        </DetailsPage>
    );
}
